/* ═══════════════════════════════════════════════════════════════════════════
   THE TABLE PLAN

   Ported from the prototype's `TABLESPEC` and `SEATING`, unchanged. These are
   the tenant's own numbers — how many tables a place has, how many sit at
   each, which room they are in — and nothing here is invented. In production
   the restaurant edits this from its console; the shape is the shape the
   editor writes.

   A row is `[how many, seats each, zone, may be joined]`.

   **Joining** is the part that is easy to leave out and then miss: two
   neighbouring tables in the same zone push together, which is how a party of
   four sits at a place whose largest free table is a two. It is marked per
   group because it is a property of the furniture, not of the room — a fixed
   booth does not move.
   ═══════════════════════════════════════════════════════════════════════ */

/** @type {Record<string, [number, number, string, 0|1][]>} */
export const PLAN = {
  sabrura: [[8, 2, 'Vindu', 1], [10, 4, 'Sal', 1], [5, 6, 'Sal', 0],
            [2, 8, 'Bakrom', 0], [1, 12, 'Selskap', 0]],
  bryggen: [[6, 2, 'Vindu', 1], [8, 4, 'Sal', 1], [5, 6, 'Sal', 0],
            [2, 8, 'Egen sal', 0]],
  fjordbord: [[6, 2, 'Sjøsiden', 1], [6, 4, 'Sal', 1], [2, 6, 'Sal', 0],
              [1, 8, 'Kjøkkenbord', 0]],
  kafenord: [[8, 2, 'Langbord', 1], [8, 4, 'Sal', 1], [3, 6, 'Sal', 0],
             [1, 8, 'Uteservering', 0]],
};

/* ── How the evening is run ───────────────────────────────────────────────

   Two ways, and they are not a setting on the same thing:

   **faste** — everybody sits at 17:30 or at 20:30. The table is yours for
   `turn` minutes and then there is `buffer` to clear it. A place that runs
   two sittings sells the room twice and needs the second sitting to start on
   time, so the free-times list is those two times and nothing between them.

   **rullerende** — tables turn over as they empty, from `from` until `last`
   entry. Free times are every half hour in that window.

   This is why a restaurant's free times cannot come from opening hours. A
   kitchen open until 23:00 with a 165-minute turn stops seating at 20:30, and
   offering 22:00 because the door is open is how a table is promised that
   cannot be given.                                                          */

/** @type {Record<string, object>} */
export const SEATING = {
  sabrura: { mode: 'faste', slots: ['17:30', '20:30'], turn: 165, buffer: 15 },
  bryggen: { mode: 'faste', slots: ['18:00', '21:00'], turn: 165, buffer: 15 },
  fjordbord: { mode: 'faste', slots: ['19:00'], turn: 180, buffer: 20 },
  kafenord: { mode: 'rullerende', from: '15:00', last: '21:00', turn: 90, buffer: 15 },
};

/** Does this business run on a table plan at all? */
export const hasPlan = businessId => !!PLAN[businessId];
